import { render, staticRenderFns } from "./k-flow-upload.vue?vue&type=template&id=1b5ac5ea"
import script from "./k-flow-upload.vue?vue&type=script&lang=js"
export * from "./k-flow-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports